const AUTH_METHOD_KEYS = [
  'idpDisplayName',
  'idpName',
  'identityProviderName',
  'identityProvider',
  'authMethod',
  'authenticationMethod',
  'providerName',
  'provider',
  'ssoProvider',
  'connectionDisplayName',
  'idp',
];

const ROLE_KEYS = ['role', 'userRole', 'membershipRole', 'tenantRole'];

function firstNonEmptyString(source, keys) {
  if (!source || typeof source !== 'object') return '';
  for (let i = 0; i < keys.length; i += 1) {
    const value = source[keys[i]];
    if (typeof value === 'string' && value.trim()) return value.trim();
  }
  return '';
}

export function workspaceDisplayName(tenant, fallbackName) {
  if (!tenant || typeof tenant !== 'object') return fallbackName;
  return (
    tenant.displayName ||
    tenant.name ||
    tenant.clientName ||
    tenant.hostname ||
    fallbackName
  );
}

export function initialsFromDisplayName(displayName) {
  const parts = String(displayName || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
  }
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return '';
}

export function isLastUsedTenant(tenant) {
  if (!tenant || typeof tenant !== 'object') return false;
  return tenant.lastUsed === true || tenant.isLastUsed === true;
}

export function tenantAuthMethod(tenant) {
  const nested =
    firstNonEmptyString(tenant?.idp, ['displayName', 'name']) ||
    firstNonEmptyString(tenant?.connection, ['displayName', 'name']);
  return firstNonEmptyString(tenant, AUTH_METHOD_KEYS) || nested;
}

export function tenantRole(tenant) {
  return firstNonEmptyString(tenant, ROLE_KEYS);
}

export function tenantMetaLine(tenant) {
  const parts = [tenantAuthMethod(tenant), tenantRole(tenant)].filter(Boolean);
  return parts.join(' · ');
}
